import { render, staticRenderFns } from "./ImageInformation.vue?vue&type=template&id=47b0f8e9&scoped=true"
import script from "./ImageInformation.vue?vue&type=script&lang=js"
export * from "./ImageInformation.vue?vue&type=script&lang=js"
import style0 from "./ImageInformation.vue?vue&type=style&index=0&id=47b0f8e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0f8e9",
  null
  
)

export default component.exports